let firebaseConfig = {};

if (process.env.REACT_APP_ENV === 'preprod') {
    console.log("preprod");
    firebaseConfig = require('./firebase.preprod').firebaseConfig;
} else {
    console.log("prod");
    firebaseConfig = require('./firebase.prod').firebaseConfig;
}

export { firebaseConfig };